import { getObjectKeysAsObject } from "@checkout/helpers";
import { TravelerGuards } from "@checkout/states/common/TravelerInformation";
import type { SelectTravelerEvent } from "@checkout/states/common/TravelerInformation/events";
import { ParentState } from "@checkout/types";
import type { PartialParentWithContactAndTraveler } from "../context";

export const Guards = {
  ...TravelerGuards,

  shouldValidateForInfant: (
    ctx: PartialParentWithContactAndTraveler,
    event: SelectTravelerEvent
  ) => {
    const currentInfantId =
      ctx[ParentState.travelerInformation].currentInfantId;

    const selectedLapInfantIds =
      ctx[ParentState.travelerInformation].selectedLapInfantIds;

    const selectedTravelerIds =
      ctx[ParentState.travelerInformation].selectedTravelerIds;

    // Check if infant modal is pending (user hasn't chosen lap vs seat yet)
    const isInfantModalPending =
      currentInfantId &&
      !selectedLapInfantIds?.includes(currentInfantId) &&
      !selectedTravelerIds?.includes(currentInfantId);

    // Don't validate if infant modal is pending - wait for user to choose seat type first
    if (isInfantModalPending) {
      return false;
    }

    return true;
  },
};

export const GuardTypes = getObjectKeysAsObject(Guards);
